(ns graph-ui.web.stale
  "THE STALE UI BANNER, AND THE CONTROL THAT CLEARS IT — the visible half of the
   UI-version contract (ADR-graph-ui-v0-010-01). graph-ui.web.core draws it
   under the top bar, on each island, when the build id of the server is not
   the build id of this browser (IKC3/PLAN-ikc-v3-060-01/FR-T).

   ;; @adr  ADR-graph-ui-v0-010-01-ui-version-contract
   ;; @plan PLAN-ikc-v3-060-01-the-fault-reports-of-2026-10-05

   WHY A CONTROL. Until 2026-10-06 the banner told the person to hard-reload
   with Ctrl/Cmd+Shift+R. A tablet and a phone have no such keys, and an app
   installed on a home screen has no browser bar to reload from. George,
   fault report 0cb9ddff, 2026-10-05: *\"I cannot do hard refresh to jump over
   Stale UI\"*. So the banner had no exit on the device he used.

   WHAT THE CONTROL DOES. It deletes the entries of the Cache Storage that
   resources/public/web/sw.js keeps, and then loads the page again. That is
   enough, and it is the whole of a hard reload here: the door sends
   index.html with no-store, and index.html names the bundle by its build id
   (ikc.bus.door/name-versioned-assets). So a plain load of the page asks for
   the new bundle by its new name, and no cache can hold an old file under it.
   The service worker answers index.html from the network first, and its cache
   only when the network fails. The delete removes that last copy too.

   UNSAVED TEXT IS NOT DISCARDED WITHOUT A QUESTION. A load of the page drops
   every buffer that graph-ui.web.unsaved keeps (STALL, never VANISH). When one
   holds text, the control asks first, and a 'no' changes nothing.

   THE EFFECTS ARE ARGUMENTS, so a test in node can drive the control with no
   window, no location and no Cache Storage (test/cljs/graph_ui/web/stale_test.cljs)."
  (:require [graph-ui.web.unsaved :as unsaved]))

(defn clear-caches!
  "Delete every Cache Storage entry of this origin, then call `done` once.
   `done` is called also when the browser has no Cache Storage (plain http on
   the LAN, or node) and when a delete fails: a cache that cannot be cleared
   must not stop the load."
  [done]
  (let [called (atom false)
        once   (fn [& _] (when (compare-and-set! called false true) (done)))]
    (if-let [cs (and (exists? js/caches) js/caches)]
      (-> (.keys cs)
          (.then (fn [ks] (js/Promise.all (into-array (map #(.delete cs %) (array-seq ks))))))
          (.then once once))
      (once))))

(defn- reload-page! [] (.reload js/location))

(defn- ask! [question] (js/confirm question))

(def unsaved-question
  "Text that you typed is not saved yet. If you load the new bundle now, that text is lost. Load it now?")

(defn load-new-bundle!
  "The control's act. Ask first when text is unsaved, then clear the caches,
   then load the page again. Answers :loading or :kept (the person said no).

   Each effect is a key of `fx`, with the browser's own as the default."
  ([] (load-new-bundle! {}))
  ([fx]
   (let [{:keys [unsaved? confirm! clear! reload!]
          :or   {unsaved? unsaved/any?*
                 confirm! ask!
                 clear!   clear-caches!
                 reload!  reload-page!}} fx]
     (if (and (unsaved?) (not (confirm! unsaved-question)))
       :kept
       (do (clear! reload!) :loading)))))

(defn banner
  "The banner for a stale-ui value {:client :server}, or nil when there is
   none. `on-load` is the control's click handler.

   THE CONTROL IS FIRST IN THE ROW, so on a phone it is on the first line and
   not under four lines of build ids."
  [stale on-load]
  (when-let [{:keys [client server]} stale]
    [:div {:class "px-3 py-2 text-sm flex items-center gap-2 flex-shrink-0 flex-wrap"
           :data-stale-ui true
           :style {:background "var(--crit)" :color "#fff"}}
     [:button {:class "px-2 py-0.5 rounded border font-semibold"
               :style {:border-color "currentColor" :min-height "var(--touch-target)"}
               :data-stale-ui-load true
               :title "Load the page again with the bundle that the server has now. This is the same as a hard reload."
               :on-click (fn [_] (on-load))}
      "↻ Load the new bundle"]
     [:span.font-semibold "⚠ Stale UI:"]
     [:span "this browser runs build"]
     [:span.font-mono client]
     [:span "and the server has build"]
     [:span.font-mono server]
     [:span.ikc-strong "— if this banner stays after the load, build the web bundle again on the server."]]))
